import React, { Component } from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import styled from 'styled-components'
import atomOneLight from '../utils/atom-one-light'
import Separator from './Separator'

export default class CodeBox extends Component {
  state = {
    showCode: false,
  }

  render() {
    const { showCode } = this.state
    const { component: DemoComponent, title, description, example } = this.props

    return (
      <Box>
        <DemoComponent />
        <div data-testid="codeTitle">
          <Separator text={title} />
        </div>
        <Description data-testid="codeDescription">
          {description}{' '}
          <span data-testid="showCode" onClick={this.toggleCode}>
            {'< >'}
          </span>
        </Description>
        {showCode && (
          <SyntaxHighlighter language="jsx" style={atomOneLight}>
            {example}
          </SyntaxHighlighter>
        )}
      </Box>
    )
  }

  toggleCode = () => {
    this.setState(state => ({ showCode: !state.showCode }))
  }
}

const Box = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  width: calc(50% - 90px);
  padding: 20px;
  margin: 20px 20px 0 0;

  @media (max-width: 1280px) {
    width: 100%;
  }
`
const Description = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span:hover {
    cursor: pointer;
  }
`
